export default {
  "Boat & Time": "Boat + Time",
  "Choose your boat and desired date and time": "Select the boat<br>One or more<br>Duration",
  "Details & Extras": "Detail Data",
  "Enter additional wishes": "Number of persons<br>Icecream on board<br>Transport to the boats",
  "Contact Details": "Your Contact Details",
  "Enter contact details": "",
  "Review & Confirm": "Review & Confirm",
  "Confirm your booking": "Confirm your booking",
  "Accept & Continue": "Accept & Continue",
  "Select slots to continue": "Select boat and time",
  "Go To Confirmation": "Go To Confirmation",
  "Confirm Booking": "Confirm Booking",
  "Back": "Back",
  "Selected date": "Selected date",
  "Price for selected": "Price for selected",
  "Cancel Booking": "Cancel Booking",
  "NOW": "NOW",
  "ADDITIONAL DETAILS": "ADDITIONAL DETAILS",
  "How many guests will be on the boat(s)?": "Number of Persons",
  "What\'s the reason for booking our boats?": "The reason for renting",
  "Do you require additional services?": "Special offers",
  "Do you have any additional wishes?": "Do you have special wishes?",
  "Do you have any additional questions?": "Do you have additional questions?",
  "Do you have a voucher code?": "Voucher code",
  "Congratulations! You are eligible for discount": "Congratulations! You are eligible for discount",
  "YOUR CONTACT DETAILS": "YOUR CONTACT DETAILS",
  "Mr or Mrs": "Mr os Mrs",
  "Mr": "Mr",
  "Mrs": "Mrs",
  "Select": "Select",
  "Dr": "Dr",
  "Prof": "Prof",
  "Mag": "Mag",
  "Title": "Title",
  "First Name": "First Name",
  "Last Name": "Last Name",
  "Company": "Company",
  "Email": "Email",
  "Telephone": "Telephone",
  "Address": "Address",
  "City": "City",
  "Post Code": "Post Code",
  "I agree to receive newsletter emails": "I agree to receive newsletter emails",
  "I agree that my photos can be used for Meine Insel promotion": "I agree that my photos can be used for Meine Insel promotion",
  "I accept the <a href=\"#\">Terms of Service</a>": "I accept the <a href=\"#\">Terms of Service</a>",
  "Please verify your booking and confirm.": "Please verify your booking and confirm.",
  "Additional Services": "Additional Services",
  "Additional Wishes": "Additional Wishes",
  "Questions": "Questions",
  "People": "People",
  "I accept the": "I accept the",
  "Terms of Service": "Terms of Service"
}


// WEBPACK FOOTER //
// ./src/translations/en.js